import React, { useState } from 'react';
import { 
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signInWithPopup
} from "firebase/auth";
import { auth, googleProvider } from '../../services/firebase';

const AuthModal = ({ mode, onClose, onAuthSuccess }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const isLogin = mode === 'login';

    const handleEmailAuth = async (e) => { 
        e.preventDefault(); 
        setError(''); 
        try { 
            if (isLogin) { 
                await signInWithEmailAndPassword(auth, email, password); 
            } else { 
                await createUserWithEmailAndPassword(auth, email, password); 
            } 
            onAuthSuccess(); 
            onClose(); 
        } catch (err) { 
            setError(err.message); 
        } 
    };
    
    const handleGoogleSignIn = async () => { 
        setError(''); 
        try { 
            await signInWithPopup(auth, googleProvider); 
            onAuthSuccess(); 
            onClose(); 
        } catch (err) { 
            setError(err.message); 
        } 
    };

    return ( 
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50" onClick={onClose}> 
            <div className="bg-white p-8 rounded-lg shadow-2xl w-full max-w-sm relative" onClick={e => e.stopPropagation()}> 
                <h2 className="text-2xl font-bold text-center mb-4">{isLogin ? 'Log In' : 'Sign Up'}</h2> 
                <button onClick={handleGoogleSignIn} className="w-full flex items-center justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 mb-4"> 
                    <svg className="w-5 h-5 mr-2" viewBox="0 0 48 48">
                        <path fill="#4285F4" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                        <path fill="#34A853" d="M46.98 24.55c0-1.57-.15-3.09-.42-4.55H24v8.51h12.8c-.57 2.73-2.21 5.08-4.79 6.69l7.98 6.19c4.63-4.28 7.39-10.49 7.39-17.84z"></path>
                        <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                        <path fill="#EA4335" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.98-6.19c-2.11 1.45-4.8 2.3-7.91 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                        <path fill="none" d="M0 0h48v48H0z"></path>
                    </svg> 
                    Continue with Google 
                </button> 
                <div className="relative flex py-2 items-center">
                    <div className="flex-grow border-t border-gray-300"></div>
                    <span className="flex-shrink mx-4 text-gray-500 text-sm">OR</span>
                    <div className="flex-grow border-t border-gray-300"></div>
                </div> 
                <form onSubmit={handleEmailAuth}> 
                    <div className="mb-4">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">Email</label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700" id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email Address" required />
                    </div> 
                    <div className="mb-6">
                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">Password</label>
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700" id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" required />
                    </div> 
                    {error && <p className="text-red-500 text-xs italic mb-4">{error}</p>} 
                    <div className="flex items-center justify-between"> 
                        <button className="text-white font-bold py-2 px-4 rounded w-full focus:outline-none focus:shadow-outline" type="submit" style={{backgroundColor: '#3D550C'}}> 
                            {isLogin ? 'Log In' : 'Sign Up'} 
                        </button> 
                    </div> 
                </form> 
                <button onClick={onClose} className="absolute top-2 right-2 text-gray-600 hover:text-gray-900">&times;</button> 
            </div> 
        </div> 
    );
};

export default AuthModal;
